import React, { useEffect } from 'react';
import { connect } from 'formik';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import Button from '@ui-lib/components/Button';
import { CreateBolFormValues } from '../const';

interface Props {
  activeStep: number;
}

export const SubmitButton = connect<Props, CreateBolFormValues>(({
  activeStep,
  formik: { handleSubmit, isSubmitting, isValid, validateForm }
}) => {

  useEffect(() => {
    validateForm();
  }, [activeStep]);

  return (
    <Button
      color="primary"
      onClick={() => handleSubmit()}
      endIcon={<ChevronRightIcon />}
      sx={{ flex: 2 }}
      size="large"
      disabled={isSubmitting || !isValid}
      loading={isSubmitting}
    >
      {activeStep === 2 ? 'Submit BOL' : 'Next Step'}
    </Button>
  );
});
